import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';
import Draggable from 'react-draggable';
import PropTypes from 'prop-types';
import config from 'cfg';
import _ from 'lodash';
import logo from '../../../images/bgr_drop_default.png';

const Area = styled.div`
    pointer-events: all;
    flex-grow: 1;
    overflow: hidden;
    position: relative;
    background-color: rgba(255, 0, 0, 0.15);
    z-index: 0;
    ${props => props.edit && 'cursor: move'};

    &:before {
        content: '';
        position: absolute;
        left: -10px;
        right: -10px;
        top: -10px;
        bottom: -10px;
        background: linear-gradient(${props => props.oa}deg, ${props => props.osc} 0%, ${props => props.oec} 100%);
        ${props => props.oa == -1 && `background: radial-gradient( ${props.osc}, ${props.oec});`} ${props =>
            props.oa == -2 && `background: radial-gradient( ${props.oec}, ${props.osc});`}
        z-index: 2;
        pointer-events: none;
    }

    ${({ edit }) =>
        edit &&
        `
    &:hover:after {
        content: '';
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        border: 3px solid #008c9d;
        z-index: 1;
        pointer-events: none;
    }
    `} ${({ active, edit }) =>
        edit &&
        active &&
        `
        &:after {
            content: '';
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            border: 3px solid #008c9d;
            z-index: 1;
            pointer-events: none;

        }
`}

    .click-to-edit {
        display: none;
    }
    &:hover .click-to-edit {
        visibility: visible;
        display: block;
        background: #008c9d;
        z-index: 100000;
    }
    box-sizing: border-box;
`;

const Img = styled.img`
    transform-origin: 0 0;
    transform: matrix(${({ position, scale }) => `${scale}, 0, 0, ${scale}, 0, 0`})
        rotateX(${({ flipY }) => (flipY ? 180 : 0)}deg) rotateY(${({ flipX }) => (flipX ? 180 : 0)}deg)
        translateY(${({ flipY }) => (flipY ? '-100%' : '0')}) translateX(${({ flipX }) => (flipX ? '-100%' : '0')}) !important;
`;

// this.sendAnEvent = _.debounce(this._sendAnEvent, 100);
const dispatch = (type, id, payload) => {
    var event = new CustomEvent('WDP_IM', {
        detail: {
            id,
            values: payload || {},
            type,
        },
        bubbles: false,
        cancelable: false,
    });

    window.dispatchEvent(event);
};

const dispatchDebounce = _.debounce(dispatch, 100);

const activate = id => {
    dispatch('ACTIVATE', id);
};

const containerResize = (id, props) => {
    dispatch('CONTAINER_RESIZE', id, props);
};

const update = (id, props) => {
    dispatchDebounce('UPDATE', id, props);
};

const change = (id, props) => {
    dispatchDebounce('CHANGE', id, props);
};

const isValid = (container, { width, height }, { scale, x, y }) => {
    const realWidth = width * scale;
    const realHeight = height * scale;

    const reachX = realWidth + x;
    const reachY = realHeight + y;

    const coverLeft = x <= 0.1;
    const coverRight = reachX - container.width >= -0.1;

    const coverTop = y <= 1;
    const coverBottom = reachY - container.height >= -0.5;

    return coverLeft && coverRight && coverTop && coverBottom;
};

const calcFitPosition = (container, dimensions) => {
    const neededScaleX = container.width / dimensions.width;
    const neededScaleY = container.height / dimensions.height;

    const scale = +Math.max(neededScaleX, neededScaleY).toFixed(3);
    const x = (container.width - dimensions.width * scale).toFixed(3) / 2;
    const y = (container.height - dimensions.height * scale).toFixed(3) / 2;

    return {
        scale,
        x,
        y,
    };
};

// replace to set state...
// this thing is not working without picker that uses redux outside widget. Why this is important?? can we use state and notify on state change redux about parameters change?
// should be refactored

class BackgroundArea extends Component {
    constructor(props) {
        super(props);
        this.state = {
            url: props.url,
        };
    }

    static defaultProps = {
        url: `${config.assets}/assets/bgr_drop_default.png`,
        flipX: false,
        flipY: false,
        scale: 1,
    };

    handleOnLoad = (src, width, height) => {
        const dimensions = {
            width,
            height,
        };

        const { x, y, scale } = this.props;
        const { container } = this.state;

        const defaultPosition = calcFitPosition(container, dimensions);
        //const valid = isValid(container, dimensions, { scale, x, y });
        const valid = true;

        const shoudReset = !valid || src !== this.state.url;

        this.setState(
            {
                url: src,
            },
            () => {
                if (shoudReset) {
                    change(this.props.id, {
                        ...BackgroundArea.defaultProps, // defs
                        width: dimensions.width, // calc new pos
                        height: dimensions.height, // calc new pos
                        cw: container.width,
                        ch: container.height,
                        ...defaultPosition,
                        url: src,
                    });
                }
            },
        );
    };

    renderFallback = () => (
        <img
            src={this.props.url}
            style={{
                width: '100%',
                height: '100%',
                objectFit: 'cover',
            }}
            alt=""
        />
    );

    componentDidMount = () => {
        const cRect = ReactDOM.findDOMNode(this.container).getBoundingClientRect();

        this.setState({ container: { width: cRect.width, height: cRect.height } });
        // hack

        this.ct_timeout = setTimeout(() => {
            this.checkForSizeChange();
        }, 500);

        if (this.props.url) {
            var img = new Image();
            const h = this.handleOnLoad;
            img.onload = function() {
                h(this.src, this.width, this.height);
            };
            img.src = this.props.url;
        }
    };

    componentWillReceiveProps(nextProps) {
        if (nextProps.url !== this.props.ulr) {
            if (nextProps.url) {
                var img = new Image();
                const h = this.handleOnLoad;
                img.onload = function() {
                    h(this.src, this.width, this.height);
                };
                img.src = nextProps.url;
            }
        }
    }

    componentWillMount = () => {
        if (this.ct_timeout) clearTimeout(this.ct_timeout);
    };

    checkForSizeChange = () => {
        const { container } = this.state;
        const el = ReactDOM.findDOMNode(this.container);

        if (!el) return console.warn('WAA');
        const cRect2 = el.getBoundingClientRect();

        if (
            cRect2 &&
            ((container && container.height !== cRect2.height) || (container && container.width !== cRect2.width))
        ) {
            // console.log('WHAT');
            this.setState({ container: { width: cRect2.width, height: cRect2.height } }, () => {
                //console.log('SEND', 'CR', this.props.id, cRect2.width, cRect2.height);
                containerResize(this.props.id, { cw: cRect2.width, ch: cRect2.height });
            });
            return true;
        }
        return false;
    };

    componentDidUpdate(prevProps, prevState) {
        this.checkForSizeChange(); // this is dangereosly
    }

    getBounds = () => {
        const { width, height, scale } = this.props;
        const { container } = this.state;
        if (!container) return {};

        const neededX = width * scale;
        const neededY = height * scale;

        return {
            left: container.width - neededX,
            top: container.height - neededY,
            right: 0,
            bottom: 0,
        };
    };

    render() {
        const { editMode, width, height, id, x, y, scale, flipX, flipY, ikey, active } = this.props;

        const { container } = this.state;
        let positionParamsAreValid = width && height;

        if (editMode && container) {
            const realWidth = width * scale;
            const realHeight = height * scale;

            const reachX = realWidth + x;
            const reachY = realHeight + y;

            const coverLeft = x <= 0.1;
            const coverRight = reachX - container.width >= -0.1;

            const coverTop = y <= 1;
            const coverBottom = reachY - container.height >= -0.5;
            positionParamsAreValid = coverLeft && coverRight && coverTop && coverBottom;
        }

        return (
            <Area
                style={this.props.style}
                ref={r => (this.container = r)}
                edit={editMode}
                onDragOver={e => {
                    e.stopPropagation();
                    e.preventDefault();
                }}
                onClick={e => {
                    activate(this.props.id);
                    e.stopPropagation();
                    e.preventDefault();
                }}
                onDrop={e => {
                    // ev.preventDefault();
                    var url = e.dataTransfer.getData('url');
                    if (url === this.props.url) return;

                    change(id, {
                        ...BackgroundArea.defaultProps, // defs
                        x: 0,
                        y: 0,
                        width: null,
                        height: null,
                        url,
                    });
                }}
                active={editMode && active}
                {...this.props}
            >
                {!editMode && !positionParamsAreValid && this.props.url && this.props.url.length
                    ? this.renderFallback()
                    : null}

                {editMode && !width && !positionParamsAreValid && (
                    <div
                        style={{
                            position: 'absolute',
                            zIndex: 100,
                            width: '100%',
                            textAlign: 'center',
                            padding: 5,
                        }}
                    />
                )}
                {/* <img
                    src={this.props.url}
                    onLoad={this.handleOnLoad}
                    style={{ opacity: 0, position: 'absolute' }}
                    alt=""
                /> */}

                <Draggable
                    defaultPosition={{ x, y }}
                    key={x + '_' + y + '_recreate'}
                    bounds={this.getBounds()}
                    disabled={!this.props.editMode}
                    onStop={(e, position) => {
                        update(this.props.id, { x: +position.x.toFixed(3), y: +position.y.toFixed(3) });
                    }}
                >
                    <div>
                        <Img
                            onError={this.onError}
                            draggable="false"
                            src={this.props.url}
                            flipX={flipX}
                            flipY={flipY}
                            scale={scale}
                            alt=""
                        />
                    </div>
                </Draggable>

                {/* <code style={{ position: 'absolute' }}>{JSON.stringify(this.props, null, 4)}</code> */}
                {editMode && <ClickToEdit className="click-to-edit" />}
            </Area>
        );
    }
}
const CTE = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    padding: 4px;
    cursor: pointer;
    postion: relative;
    background: #000;
    color: #fff;
    z-index: 100000;
`;
const ClickToEdit = props => (
    <CTE {...props}>
        <span>Click to edit</span>
    </CTE>
);

BackgroundArea.propTypes = {
    url: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number,
    autoadjust: PropTypes.bool,
};

export default BackgroundArea;

// export default props => <div>{JSON.stringify(props)}</div>;



/** WEBPACK FOOTER **
 ** ../src/widgets/components/interactive/topScorersMulti/DropBackground.js
 **/